/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Base environment settings.
 * This base environment config can be overriden in environment-specific configs.
 *
 * @file base.js
 * @author JP
 * @since 1.0.0
 */

const base = {
  GLS_API_BASE_URL: 'https://api-stg.gls.pearson-intl.com/product',
  GLS_APP_ID: '56dd9b6c1d40e68e859eedb1',
  TIMEOUT: 6000
};

export default base;
